import AccountsItem from 'views/Accounts/Item'
import { TAccountWithRoles } from 'types/accounts'

type TProps = {
  accounts: TAccountWithRoles[] | undefined
}

const AccuntsList = ({ accounts }: TProps) => {
  return (
    <div className="item-list">
      {accounts?.map(({ firstName, lastName, email, accountStatus, id, userRolesNames }) => (
        <AccountsItem
          firstName={firstName}
          lastName={lastName}
          email={email}
          roles={userRolesNames}
          status={accountStatus}
          key={id}
          id={id}
        />
      ))}
    </div>
  )
}

export default AccuntsList
